import React from "react";
import BreadCrumb from "common/breadcrumb";
import BasicDropdown from "./basic-dropdown";
import SplitDropdowns from "./split-dropdowns";
import VariantDropdown from "./variant-dropdown";
import DropdownContent from "./dropdown-content";

const UiDropdown = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Dropdown' pageTitle='UI Elements' />

                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-2">
                    <BasicDropdown />
                    <SplitDropdowns />
                    <VariantDropdown />
                    <DropdownContent />
                </div>
            </div>
        </React.Fragment>
    );
}

export default UiDropdown;